<div class="error-wrapper congratulations-bg">
	<div class="container">
		<div class="maintenance-heading">
			<h2 class="text-gradient headline">{{ 'Congratulations' | translate }} !</h2>
		</div>
		<h3 class="text-gradient">{{ 'Tasyire congratulates you for joining our community' | translate }}</h3>
		<p class="lead text-gradient">
			{{
				'Your account has been created and is currently disabled. Our team will contact you shortly to configure your account and enable access. Thank you for your patience.'
					| translate
			}}
		</p>
		<div>
			<a class="btn btn-tasyire-color-gradien btn-lg text-light" [routerLink]="['/auth/login']">{{
				'BACK TO LOGIN PAGE' | translate
			}}</a>
		</div>
	</div>
</div>
